import * as React from 'react'
import { useGlobalCtx } from '@providers/global-context'
import { SignFormCard } from '@shared/components/forms/sign/components/card'
import { TextField } from '@shared/components/text-field'
import { formatPhone } from '@shared/utils/helpers'
import cx from 'clsx'
import { FormikProvider } from 'formik'

import { useSignForm } from '../../..'
import { useSmsRetry } from '../../../shared/hooks/use-sms-retry'

import { IStateProps, Step2FormModel } from './model'

import styles from './styles.module.scss'

export const View = ({ formik }: IStateProps) => {
	const { isRunning, text, retry } = useSmsRetry()
	const { toggleSpoiler } = useSignForm()
	const {
		globalCtx: {
			user: { phone },
		},
	} = useGlobalCtx()

	const values = formik.values as Step2FormModel

	React.useEffect(() => {
		if (values.code.length === 4) {
			formik.submitForm()
		}
	}, [values.code])

	return (
		<FormikProvider value={formik}>
			<SignFormCard onToggleSpoiler={toggleSpoiler}>
				<form className={styles.indentXs} onSubmit={formik.handleSubmit} autoComplete='off'>
					<h4 className={styles.title}>Подпишите документы</h4>
					<p className={cx(styles.text, styles.indentXs)}>
						Мы отправили на номер {formatPhone(phone)} смс с кодом.
					</p>
					<p className={cx(styles.text, styles.indentS)}>
						Введите его, чтобы завершить оформление заявки:
					</p>
					<TextField
						mask='9999'
						maskChar=''
						required
						onChange={formik.handleChange}
						value={values.code}
						className={styles.input}
						inputMode='numeric'
						error={formik.status === 'wrong_code'}
						name='code'
						label='Код из смс'
						disabled={formik.isSubmitting}
					/>
				</form>
				<div className={styles.bottom}>
					<span
						className={cx(styles.retry, { [styles.disabled]: isRunning })}
						onClick={!isRunning ? retry : undefined}
					>
						{text}
					</span>
				</div>
				{formik.status === 'wrong_code' && (
					<span className={styles.error}>Неправильный код подтверждения</span>
				)}
			</SignFormCard>
		</FormikProvider>
	)
}
